import { combineReducers } from 'redux';

import getCategories from './getCategoriesReducer';
import getSubCategories from './getSubCategoriesReducer';
import postContactUsForm from './postContactUsFormReducer';

export default combineReducers({
  categories: getCategories,
  subCategories: getSubCategories,
  postContactUsForm: postContactUsForm,
});
